import { render } from "./VirtualWarehouse.vue?vue&type=template&id=79ef9e0f&scoped=true"
import script from "./VirtualWarehouse.vue?vue&type=script&lang=js"
export * from "./VirtualWarehouse.vue?vue&type=script&lang=js"

import "./VirtualWarehouse.vue?vue&type=style&index=0&id=79ef9e0f&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-79ef9e0f"]])

export default __exports__